import React from 'react';

import { FormattedMessage } from 'react-intl';

import messagesDE from './PersonalInformationDE.messages';
import FormField from '../../components/FormField';
import { germanPostcodeFormatter } from '../../helpers/helpers';
import normalizer from '../../helpers/inputNormalizer';
import { FieldWrapper } from '../PersonalInformation/types/PersonalInformation.types';

const PostcodeQuestion = (props: { field: FieldWrapper<string> }) => {
    const getNormaliserWithField = () => {
        return normalizer(props.field, germanPostcodeFormatter, null);
    };

    const renderLabel = () => {
        return <FormattedMessage {...messagesDE.postcode} />;
    };

    const field = getNormaliserWithField();
    const label = renderLabel();

    return (
        <FormField wrapperClassName="fs-exclude" field={field} label={label}>
            <FormField.Input className="xs-push" maxLength={5} />
        </FormField>
    );
};

export default PostcodeQuestion;
